var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"tree"},[_c('tree-node',{attrs:{"item":_vm.treeNodes,"open-default":true,"toggle-handler":_vm.toggle,"select-handler":_vm.select}})],1),_c('div',{attrs:{"id":"file-explorer-context-menu"}})])}
var staticRenderFns = []

export { render, staticRenderFns }